<template>
<div>
    <Navbar />
    <Breadcrumbs></Breadcrumbs>
    <EmployeesCarnet/>
    <Footer />
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import EmployeesCarnet from '@/components/employees/EmployeesCarnet.vue'
import Footer from '@/components/Footer.vue';

export default {
    components: {
        Navbar,
        EmployeesCarnet,
        Footer
    }
}
</script>

<style scoped>

</style>